'use client';

import { Elements } from '@stripe/react-stripe-js';
import { CreateListingProcess } from 'app/create-listing/_components/CreateListingProcess';
import { CreateListingProvider } from 'app/create-listing/_context';
import { useAuth } from 'context/AuthContext';
import { useStripeContext } from 'context/StripeContext';
import { NuqsAdapter } from 'nuqs/adapters/next/app';

export default function Page() {
  const { stripePromise } = useStripeContext();
  const { userDoc } = useAuth();
  if (!userDoc) return null;
  return (
    <Elements stripe={stripePromise}>
      <NuqsAdapter>
        <CreateListingProvider initialStep="create-listing">
          <CreateListingProcess />
        </CreateListingProvider>
      </NuqsAdapter>
    </Elements>
  );
}
